/**
 * ApplicationsBadge — счётчик заявок «на рассмотрении» у пункта «Заявки»
 * в сайдбаре (ADMIN_SPEC: statusCounts «для бейджей в меню»). Обновляется
 * при инвалидации домена applications после смены статуса.
 */

import {useQuery} from '@tanstack/react-query';

import {getApplications} from '@services/applications';
import {keys} from '@queries/keys';

export const ApplicationsBadge = () => {
  const {data} = useQuery({
    queryKey: keys.applications.list({scope: 'badge'}),
    queryFn: () => getApplications({page: 1, pageSize: 1}),
    staleTime: 60_000,
  });

  const pending = data?.statusCounts.pending ?? 0;
  if (pending === 0) return null;

  return (
    <span className="ml-auto rounded-full bg-primary px-[7px] py-px font-mono text-[11px] font-semibold text-primary-foreground">
      {pending}
    </span>
  );
};
